/* if adding a new flag, update use-record-all-flags.ts */

"use client";

import { usePostHogFlag } from "../use-posthog-flag";

export function useUserCanAccessWhitelabel() {
  return usePostHogFlag("user_can_access_whitelabel");
}
